import { render, staticRenderFns } from "./ASstudent.vue?vue&type=template&id=0113e9f0"
import script from "./ASstudent.vue?vue&type=script&lang=js"
export * from "./ASstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports